import React from "react";

// theme: light
export default function BadgeNumber({ count, theme = "default" }) {
  return (
    <div className={`badge-counter badge-counter-${theme}`}>
      <p className="count">{count}</p>
    </div>
  );
}
